import { render } from "./DoctorSummaryForm.vue?vue&type=template&id=6ac0ccd4&scoped=true"
import script from "./DoctorSummaryForm.vue?vue&type=script&lang=js"
export * from "./DoctorSummaryForm.vue?vue&type=script&lang=js"

import "./DoctorSummaryForm.vue?vue&type=style&index=0&id=6ac0ccd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac0ccd4"]])

export default __exports__